import React from 'react'
import { Position } from '@xyflow/react'
import type { ProjectLabel } from '@bandos/shared'
import type { LabelContextType } from '../../../../context/label/LabelContextDef'
import { SparkleLoader } from '../../../common/SparkleLoader'
import { NodeLabels } from '../Base/components/NodeLabels'
import { StoryboardNodeHeader } from './StoryboardHeader'
import {
  StoryboardWrapper,
  StoryboardNodeContainer,
  StoryboardTargetHandle,
  GeneratingContainer,
  GeneratingMessage,
} from '../styles/StoryboardNodeStyles'

interface StoryboardGeneratingViewProps {
  nodeId: string
  zoomScale: number
  displayTitle: string
  isReadOnly: boolean
  labelsEnabled: boolean
  labels: ProjectLabel[] | undefined
  mindmapId: string | undefined
  labelContext: LabelContextType
  onDeleteNode: (nodeId: string) => void
  onSelectLabel: (labelId: string) => Promise<void>
  onCreateLabel: (labelText: string, color: string) => Promise<void>
  onRemoveLabel: (labelId: string) => Promise<void>
  onDeleteLabel: (labelId: string) => Promise<void>
}

export const StoryboardGeneratingView = React.memo(
  ({
    nodeId,
    zoomScale,
    displayTitle,
    isReadOnly,
    labelsEnabled,
    labels,
    mindmapId,
    labelContext,
    onDeleteNode,
    onSelectLabel,
    onCreateLabel,
    onRemoveLabel,
    onDeleteLabel,
  }: StoryboardGeneratingViewProps) => {
    return (
      <StoryboardWrapper $zoomScale={zoomScale}>
        <StoryboardNodeContainer $isGenerating={true}>
          <StoryboardTargetHandle
            type="target"
            position={Position.Left}
            id="target"
            isConnectableStart={false}
          />
          <StoryboardNodeHeader
            nodeId={nodeId}
            zoomScale={zoomScale}
            displayTitle={displayTitle}
            onDeleteNode={onDeleteNode}
          />
          <GeneratingContainer>
            <SparkleLoader isAnimating={true} size={80} />
            <GeneratingMessage>Creating your storyboard...</GeneratingMessage>
          </GeneratingContainer>
        </StoryboardNodeContainer>
        {labelsEnabled && (
          <NodeLabels
            labels={labels}
            nodeId={nodeId}
            mindmapId={mindmapId}
            isReadOnly={isReadOnly}
            labelContext={labelContext}
            onSelectLabel={onSelectLabel}
            onCreateLabel={onCreateLabel}
            onRemoveLabel={onRemoveLabel}
            onDeleteLabel={onDeleteLabel}
          />
        )}
      </StoryboardWrapper>
    )
  }
)

StoryboardGeneratingView.displayName = 'StoryboardGeneratingView'
